// extracted by mini-css-extract-plugin
export default {"popup":"AtpPopup__popup--2C0","isModal":"AtpPopup__isModal--5Cr","inner":"AtpPopup__inner--33U","wrapper":"AtpPopup__wrapper--1zu"};